import React, { useState } from 'react';

function TreeView({
    categories = [],
    parentId = 0,
    selectedCategoryId,
    onSelectCategory,
    onShowAll,
    depth = 0,
}) {
    const [expandedCategories, setExpandedCategories] = useState([]);

    const categoryHasChildren = (categoryId) =>
        categories.some((category) => category.parentCategoryId === categoryId);

    const toggleExpanded = (categoryId) => {
        setExpandedCategories((prev) =>
            prev.includes(categoryId) ? prev.filter((id) => id !== categoryId) : [...prev, categoryId]
        );
    };

    const handleCategoryClick = (category) => {
        const hasChildren = categoryHasChildren(category.id);

        if (hasChildren) {
            toggleExpanded(category.id);
            return;
        }

        onSelectCategory(category.id, category.title);
    };

    const renderCategories = (currentParentId, currentDepth = 0) =>
        categories
            .filter((category) => category.parentCategoryId === currentParentId)
            .map((category) => {
                const hasChildren = categoryHasChildren(category.id);
                const isExpanded = expandedCategories.includes(category.id);
                const isSelected = selectedCategoryId === category.id;

                return (
                    <div key={category.id} className="tree-item-wrapper mb-1">
                        <div className={`tree-item ${isSelected ? 'selected' : ''}`}>
                            <button
                                type="button"
                                className="tree-item-button btn d-flex align-items-center w-100 text-start border-0 rounded-3"
                                onClick={() => handleCategoryClick(category)}
                            >
                                <div className="d-flex align-items-center flex-grow-1 min-width-0">
                                    {hasChildren ? (
                                        <span
                                            className={`tree-toggle-icon me-1 ${isExpanded ? 'expanded' : ''}`}
                                            aria-hidden="true"
                                        >
                                            <i className="bi bi-chevron-down"></i>
                                        </span>
                                    ) : (
                                        <span className="tree-toggle-icon me-1" style={{ visibility: 'hidden' }}>
                                            <i className="bi bi-chevron-down"></i>
                                        </span>
                                    )}

                                    <span className="tree-item-icon me-2">
                                        <i
                                            className={`bi ${
                                                hasChildren
                                                    ? isExpanded
                                                        ? 'bi-folder2-open'
                                                        : 'bi-folder2'
                                                    : 'bi-file-earmark-text'
                                            }`}
                                        ></i>
                                    </span>

                                    <span className="tree-item-label text-wrap">{category.title}</span>
                                </div>

                                {hasChildren && (
                                    <span className="badge rounded-pill bg-light text-dark flex-shrink-0 ms-2">
                                        {categories.filter((cat) => cat.parentCategoryId === category.id).length}
                                    </span>
                                )}
                            </button>
                        </div>

                        {isExpanded && hasChildren && (
                            <div className="tree-children-container">
                                {renderCategories(category.id, currentDepth + 1)}
                            </div>
                        )}
                    </div>
                );
            });

    return (
        <div>
            <div className="tree-item-wrapper mb-2">
                <div className={`tree-item ${selectedCategoryId === null ? 'selected' : ''}`}>
                    <button
                        type="button"
                        className="tree-item-button btn d-flex align-items-center w-100 text-start border-0 rounded-3"
                        onClick={onShowAll}
                    >
                        <div className="d-flex align-items-center flex-grow-1 min-width-0">
                            <span className="tree-toggle-icon me-1" style={{ visibility: 'hidden' }}>
                                <i className="bi bi-chevron-down"></i>
                            </span>
                            <span className="tree-item-icon me-2">
                                <i className="bi bi-journals"></i>
                            </span>
                            <span className="tree-item-label fw-semibold">All Articles</span>
                        </div>
                    </button>
                </div>
            </div>

            {categories.length > 0 ? (
                renderCategories(parentId, depth)
            ) : (
                <div className="ecx-page-empty py-4">
                    <div className="ecx-page-empty__icon" style={{ width: '3rem', height: '3rem', fontSize: '1.25rem' }}>
                        <i className="bi bi-inbox"></i>
                    </div>
                    <p className="mb-0">No categories available</p>
                </div>
            )}
        </div>
    );
}

export default TreeView;
